<template>
	<div class="bar-chart">
		<chart-base :chart-options="options" :height="height" :width="width"></chart-base>
	</div>
</template>

<script>
import chartMixin, { getMax, getLabel } from './chartMixin.js'

const barWidth = 25

export default {
	name: 'BarChart',
	mixins: [chartMixin],
	computed: {
		options() {
			const label = getLabel(
				{
					align: 'center',
					verticalAlign: 'middle',
					rotateAlign: 'center',
					rotateDistance: 14,
					distance: 10,
				},
				this.chartOptions.series,
			)
			const baseConfig = {
				color:
					this.chartStyle === 'blue'
						? ['rgba(87, 179, 195, 0.6)', 'rgba(237, 156, 81, 0.6)', 'rgba(213, 79, 81, 0.6)']
						: ['rgba(83, 94, 215, 0.6)', 'rgba(51, 178, 210, 0.6)', 'rgba(172, 119, 255, 0.6)'],
				grid: {
					top: '16%',
				},
				legend: {
					top: 0,
					itemWidth: 10,
					itemHeight: 10,
				},
				xAxis: {
					type: 'category',
					data: [],
					axisLine: {
						lineStyle: {
							color: '#E8E8E8',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						show: true,
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
					axisTick: {
						show: false,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
						formatter: value => {
							if (value === 0) return '0'
							if (value > 1000) return `${(value / 1000).toFixed(1)}k`
							return value
						},
					},
					max: getMax,
					minInterval: 1,
				},
				series: [
					{
						type: 'bar',
						barWidth,
						data: this.data,
						showBackground: true,
						label,
					},
					{
						type: 'bar',
						barWidth,
						data: this.data,
						showBackground: true,
						label,
					},
					{
						type: 'bar',
						barWidth,
						data: this.data,
						showBackground: true,
						label,
					},
				],
			}

			const seriesCount = (this.chartOptions.series || []).length

			baseConfig.series = baseConfig.series.slice(0, seriesCount)

			const colors = baseConfig.color || []
			const pictorialHeight = 3

			const mergedOptions = this.mergeOptions(baseConfig, this.chartOptions)

			const series = []
			for (let i = 0; i < seriesCount; i++) {
				const color = colors[i] || colors[i % colors.length] || '#999'
				const barSeries = mergedOptions.series[i]
				if (!barSeries) continue
				const seriesData = barSeries.data
				if (!seriesData) continue
				series.push(barSeries)
				// 顶端的小方块，使用 pictorialBar 放在柱顶（symbolPosition: 'end'）
				series.push({
					type: 'pictorialBar',
					barWidth: barSeries.barWidth,
					symbol: 'rect',
					barGap: '20%',
					symbolSize: [barSeries.barWidth, pictorialHeight],
					symbolOffset: [0, -3],
					symbolPosition: 'end',
					data: seriesData,
					itemStyle: {
						color: color.replace('0.6', '1'),
					},
					z: 10,
					showLegendSymbol: false,
				})
			}

			mergedOptions.series = series

			// 合并传入的配置
			return mergedOptions
		},
	},
}
</script>

<style lang="scss" scoped>
.bar-chart {
	width: 100%;
	height: 100%;
}
</style>
